import React from 'react'
import styled from "./SideDiv1.module.css"
const SideDiv7 = () => {
    return (
        <div style={{ textAlign: "left" }} className={styled.div1} >
            <h3>Top Skills</h3>
            <p style={{ color: "#4a90e2" }}>Mechanical Engineering Jobs
BPO Jobs <br />
Networking Jobs <br />
Java Jobs <br />
Online Marketing Jobs <br />
Animation Jobs <br />
Design Engineer Jobs <br />
Analytics Jobs <br />
UI/UX Jobs <br />
NLP Jobs <br />
Banking Jobs <br />
MBA Jobs <br />
Teaching Jobs <br />
Marketing Jobs <br />
Accounting Jobs <br />
Retail Jobs <br />
Travel Jobs <br />
Merchandiser Jobs <br />
Architecture Jobs</p>
        </div>
    )
}

export default SideDiv7
